
export default {
  name: "PostOverview",
  props: {
    posts: Array,
    postType: String,
  },
  methods: {
    isEvenWithoutFullWidth(currentIndex) {
      let count = 0;
      for (let index = 0; index <= currentIndex; index++) {
        if (!this.posts[index].attributes.fullWidth) {
          count++;
        }
      }
      return count % 2 === 0;
    },
  },
}
